var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: {
        focused: _vm.isFocused,
        empty: !_vm.value,
        "is-error": _vm.error,
      },
    },
    [
      _c("input", {
        ref: "search",
        attrs: { type: "search", disabled: _vm.disabled },
        domProps: { value: _vm.value },
        on: {
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              )
                return null
              return _vm.typeAheadUp.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown",
                ])
              )
                return null
              return _vm.typeAheadDown.apply(null, arguments)
            },
          ],
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.typeAheadSelect.apply(null, arguments)
          },
          input: _vm.changeSearchValue,
        },
      }),
      _vm._v(" "),
      _vm.label ? _c("label", [_vm._v(_vm._s(_vm.appliedLabel))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLookupOpen,
              expression: "isLookupOpen",
            },
          ],
          ref: "dropdownMenu",
          staticClass: "v-dropdown card",
        },
        _vm._l(_vm.options, function (option, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "card",
              class: {
                highlight: index === _vm.typeAheadPointer,
                separator: option.separator,
                paddedLarge: option.level,
              },
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.select(option)
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(option[_vm.optionLabel]))]),
              _vm._v(" "),
              _c("span", { staticClass: "search-subtitle" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(option.sector) +
                    ", " +
                    _vm._s(option.baseCountry) +
                    "\n      "
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      _vm.required && !_vm.value
        ? _c("span", { staticClass: "error" }, [
            _vm._v(_vm._s(_vm.requiredMessage)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }